import { render, staticRenderFns } from "./AssetAdditonalFieldsWidgetComponent.vue?vue&type=template&id=2648b074&"
import script from "./AssetAdditonalFieldsWidgetComponent.vue?vue&type=script&lang=js&"
export * from "./AssetAdditonalFieldsWidgetComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports